import { SET_STATE_SIDEBAR } from "./sidebar.action";

const InitState = {
  isActive: false,
};

export default function SideBarReducer(state = InitState, action) {
  switch (action.type) {
    case SET_STATE_SIDEBAR: {
      return {
        ...state,
        isActive: action.payload,
      };
    }
    default:
      return state;
  }
}
